import React, { useEffect } from 'react';
import { HashRouter as Router } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import 'react-toastify/dist/ReactToastify.css';

const INACTIVITY_TIMEOUT = 30 * 60 * 1000;

const App = () => {
  useEffect(() => {
    const handleActivity = () => {
      clearTimeout(window.logoutTimer);
      window.logoutTimer = setTimeout(handleLogout, INACTIVITY_TIMEOUT);
    };

    const handleLogout = () => {
      sessionStorage.clear();
      window.location.href = '/';
    };

    document.addEventListener('mousemove', handleActivity);
    document.addEventListener('keypress', handleActivity);

    window.logoutTimer = setTimeout(handleLogout, INACTIVITY_TIMEOUT);

    return () => {
      document.removeEventListener('mousemove', handleActivity);
      document.removeEventListener('keypress', handleActivity);
      clearTimeout(window.logoutTimer);
    };
  }, []);

  return (
    <Router>
      <AppRoutes />
    </Router>
  );
};

export default App;
